import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart",
  "use": "heart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"heart\"><path fill-rule=\"evenodd\" d=\"m12 19.34-1.164-1.051c-2.079-1.828-3.731-3.456-4.958-4.883C4.65 11.98 4.025 10.526 4 9.05c.025-1.252.45-2.29 1.277-3.117.826-.826 1.865-1.252 3.117-1.277.701 0 1.365.15 1.991.45A5.14 5.14 0 0 1 12 6.309c.45-.501.989-.902 1.615-1.202.626-.3 1.29-.451 1.99-.451 1.253.025 2.292.45 3.118 1.277.826.826 1.252 1.865 1.277 3.117-.025 1.478-.651 2.93-1.878 4.357-1.227 1.427-2.88 3.055-4.958 4.883L12 19.34Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol